export default __webpack_public_path__ + "static/media/calconvert_background_s2.cde09cf7.jpg";